export enum PaymentMode {
    cash = "630eb471-ae7c-4ab2-84db-ac1920ecfcc1",
    creditCard = "7a9200c0-5568-4eff-9bad-68317d7d0dcd",
    debitCard = "4a6d6dc1-6440-4296-9a66-2c55aae5a599",
    enach = "a1cb94a0-d407-4876-ac70-00b8e7bbe90e",
    netBanking = "55355c85-ae01-4d03-a2d6-8c055b7eb712",
    si = "0837e31b-f99c-41de-9d52-8aa60a91d561",
    upi = "353e1001-c6cd-4cf3-b1c0-564b8ddb7191",
}
